import { environmentHttpClient } from "client/Api/httpClient";
import { UserGridItem } from "../UserManagement/userManagement";
import { UserGroupPermissionsModel } from "./Permissions/userGroupPermissions";

export enum UserGroupManagementMode {
	ReadonlyExceptMemberPermissions = 1,
	Edit = 2
};

export type EditUserGroupPageModel = {
	userGroup: UserGroupModel | null;
	userGroupManagementMode: UserGroupManagementMode;
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
};

export type UserGroupModel = {
	id: number | null;
	name: string;
	description: string;
	selectedUserIds: readonly number[];
	selectedUserGroupIds: readonly number[];
	permissions: UserGroupPermissionsModel;
};

export type SaveUserGroupMemberPermissionsModel = {
	id: number;
	permissions: UserGroupPermissionsModel;
};

export type UserGroupOverviewModel = {
	id: number;
	name: string;
	description: string;
	numberOfUsers: number;
	numberOfNonDeletedDirectUsers: number;
	numberOfActiveNonDeletedDirectUsers: number;
};

export type UserGroupsPageModel = {
	userGroups: readonly UserGroupOverviewModel[];
	groupRelations: Record<number, readonly number[] | undefined>;
	userGroupManagementMode: UserGroupManagementMode;
};

export function getPageViewModel(signal?: AbortSignal): Promise<UserGroupsPageModel> {
	return environmentHttpClient.get<UserGroupsPageModel>(
		"UiApi/UserGroupsManagement",
		undefined,
		{ signal }
	);
}

export function getCreateViewModel(signal?: AbortSignal): Promise<EditUserGroupPageModel> {
	return environmentHttpClient.get<EditUserGroupPageModel>(
		"UiApi/UserGroupsManagement/Create",
		undefined,
		{ signal }
	);
}

export function getEditViewModel(id: number, signal?: AbortSignal): Promise<EditUserGroupPageModel> {
	return environmentHttpClient.get<EditUserGroupPageModel>(
		`UiApi/UserGroupsManagement/Edit/${id}`,
		undefined,
		{ signal }
	);
}

export function save(
	model: UserGroupModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.post<void>(
		"UiApi/UserGroupsManagement/Save",
		model,
		{ signal }
	);
}

export function saveMemberPermissions(
	model: SaveUserGroupMemberPermissionsModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		"UiApi/UserGroupsManagement/SaveMemberPermissions",
		model,
		{ signal }
	);
}

export function deleteUserGroup(
	id: number,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.delete<void>(
		`UiApi/UserGroupsManagement/${id}`,
		undefined,
		{ signal }
	);
}

export type UsersAndUserGroupsDataModel = {
	users: readonly UserGridItem[];
	userGroups: readonly UserGroupOverviewModel[];
};
